import request from '@/utils/request'
import URL from '@/api/urlTranslator'

// 根据条件查询所有群组信息
export function getMailGroupList(params) {
  return request({
    url: URL.mdm.mailGroup,
    method: 'get',
    params
  })
}

// 新增邮件群组
export function addMailGroup(data) {
  return request({
    url: `${URL.mdm.mailGroup}`,
    method: 'post',
    data
  })
}

// 编辑邮件群组
export function editMailGroup(data) {
  return request({
    url: `${URL.mdm.mailGroup}`,
    method: 'put',
    data
  })
}

// 根据uuid删除邮件群组
export function deleteMailGroup(uuid) {
  return request({
    url: `${URL.mdm.mailGroup}/${uuid}`,
    method: 'delete'
  })
}
